import Bowser from 'bowser';

let browser: Bowser.Parser.Parser | null = null;

export function getBrowser() {
  if (!browser) {
    browser = Bowser.getParser(
      typeof window !== 'undefined' ? window.navigator.userAgent : '',
    );
  }
  return browser;
}

export function openUrlWithCurrentPageFallback(url: string) {
  if (typeof window === 'undefined') {
    return;
  }

  const opened = window.open(url, '_blank');

  if (!opened) {
    window.location.assign(url);
  }
}
